import { useEffect, useState } from 'react';
import { DataTable, Column, Badge } from '../../../shared/components';
import { getReportsRepository } from '../../../shared/services/reports/repositoryFactory';
import { NovedadKpiRow, ReportFilters } from '../../../shared/services/reports/types';
import { KpiPanelShell } from './KpiPanelShell';
import { KpiBarList } from './KpiBarList';

const repo = getReportsRepository();

export function NovedadKpiPanel({ filters }: { filters: ReportFilters }) {
  const [rows, setRows] = useState<NovedadKpiRow[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    repo.novedades(filters, 1, 200).then((res) => {
      setRows(res.items);
      setIsLoading(false);
    });
  }, [filters]);

  const columns: Column<NovedadKpiRow>[] = [
    { key: 'userName', header: 'Colaborador', render: (r) => r.userName, sortable: true, sortValue: (r) => r.userName },
    { key: 'modifiedCount', header: 'Modificados', render: (r) => <Badge tone="warning">{r.modifiedCount}</Badge>, sortable: true, sortValue: (r) => r.modifiedCount },
    { key: 'deletedCount', header: 'Borrados', render: (r) => <Badge tone="critical">{r.deletedCount}</Badge>, sortable: true, sortValue: (r) => r.deletedCount },
  ];

  return (
    <KpiPanelShell title="Modificados / Borrados por colaborador" subtitle="Trazabilidad: cuántos registros ha modificado o eliminado cada colaborador">
      {!isLoading && (
        <div className="mb-4">
          <KpiBarList
            rows={rows.slice(0, 6).map((r) => ({ label: r.userName, value: r.modifiedCount + r.deletedCount, displayValue: `${r.modifiedCount + r.deletedCount}` }))}
          />
        </div>
      )}
      <DataTable columns={columns} rows={rows} rowKey={(r) => r.userId} isLoading={isLoading} emptyTitle="Sin novedades registradas" pageSize={5} />
    </KpiPanelShell>
  );
}
